import { MixpanelEvent, useMixpanel } from '@talos/kyoko';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPositionAutoHedgingRulesRoute } from '../../containers/Routes/routes';
import { useCurrentAppLayoutId } from '../../hooks/useAppLayoutId';

/**
 * Hook to navigate to the Position Autohedging setup tab
 */
export function useNavigateToHedgeRulesSetup() {
  const mixpanel = useMixpanel();
  const navigate = useNavigate();
  const layoutId = useCurrentAppLayoutId();

  return useCallback(() => {
    mixpanel.track(MixpanelEvent.NavigateToHedgeRulesTab);
    navigate(getPositionAutoHedgingRulesRoute({ layoutId }));
  }, [mixpanel, navigate, layoutId]);
}
